import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import './NoActivePackageDialog.css';

interface NoActivePackageDialogProps {
  show: boolean;
  lowCoins?: boolean;
  expiringInDays?: number | null;
  onClose: () => void;
  onChoosePackage: () => void;
}

const NoActivePackageDialog: React.FC<NoActivePackageDialogProps> = ({
  show,
  lowCoins = false,
  expiringInDays = null,
  onClose,
  onChoosePackage
}) => (
  <Modal
    show={show}
    onHide={onClose}
    centered
    dialogClassName="no-active-package-dialog"
    aria-labelledby="no-active-package-title"
  >
    <Modal.Header closeButton className="no-active-package-header">
      <Modal.Title id="no-active-package-title" className="no-active-package-title">
        {expiringInDays !== null
          ? `Your training package is ending in ${expiringInDays} ${expiringInDays === 1 ? 'day' : 'days'}. Choose a new package or membership and keep your training going.`
          : lowCoins
            ? 'You’re running low on Dance Coins. Choose a new package or membership and keep your training going.'
            : 'You don’t have any active training package'}
      </Modal.Title>
    </Modal.Header>
    <Modal.Footer className="no-active-package-footer">
      <Button className="no-active-package-button" onClick={onChoosePackage}>
        Choose package or membership
      </Button>
    </Modal.Footer>
  </Modal>
);

export default NoActivePackageDialog;
